import { render, staticRenderFns } from "./office365_general.vue?vue&type=template&id=ae5420bc&"
import script from "./office365_general.vue?vue&type=script&lang=js&"
export * from "./office365_general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports